var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVipLoungeServiceFax(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 2.44799V6.54999C5 6.79799 5.202 6.99999 5.45 6.99999H14.55C14.798 6.99999 15 6.79799 15 6.54999V2.44799C15 2.19999 14.798 1.99799 14.55 1.99799H5.45C5.202 1.99799 5 2.19799 5 2.44799ZM14 5.99999L6 6.08999V2.99999H14V5.99999Z",
    fill: "#FFC629"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 6H4C2.896 6 2 6.896 2 8V14C2 15.104 2.896 16 4 16H6V14.51H4.5C3.948 14.51 3.5 14.062 3.5 13.51V8.5C3.5 7.948 3.948 7.5 4.5 7.5H15.5C16.052 7.5 16.5 7.948 16.5 8.5V13.51C16.5 14.062 16.052 14.51 15.5 14.51H14V16H16C17.104 16 18 15.104 18 14V8C18 6.894 17.104 6 16 6Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.75 10C15.1642 10 15.5 9.66421 15.5 9.25C15.5 8.83579 15.1642 8.5 14.75 8.5C14.3358 8.5 14 8.83579 14 9.25C14 9.66421 14.3358 10 14.75 10Z",
    fill: "#FFC629"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 17.55V12.45C15 12.202 14.798 12 14.55 12H5.45C5.202 12 5 12.202 5 12.45V17.55C5 17.798 5.202 18 5.45 18H14.55C14.798 18 15 17.798 15 17.55ZM6 13L14 12.91V16.996H6V13Z",
    fill: "#FFC629"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVipLoungeServiceFax);
export default __webpack_public_path__ + "static/media/vip-lounge-service-fax.d19a4c218e32141f1d310911423a5773.svg";
export { ForwardRef as ReactComponent };